import type { FuncOverrideComponent } from '../theme.types';

export const MuiLinearProgress: FuncOverrideComponent<'MuiLinearProgress'> = theme => ({
  styleOverrides: {
    colorPrimary: {
      backgroundColor: theme.palette.primary.light,
    },
  },
});
